import { useSyncExternalStore } from 'react';
import { useTheme } from 'styled-components';

const useMediaQuery = (query: string) => {
  return useSyncExternalStore(
    (callback) => {
      const mediaQuery = window.matchMedia(query);
      mediaQuery.addEventListener('change', callback);
      return () => mediaQuery.removeEventListener('change', callback);
    },
    () => window.matchMedia(query).matches,
    () => false, // SSR fallback
  );
};

export const useBreakpoints = () => {
  const theme = useTheme();

  return {
    isMobile: useMediaQuery(`(max-width: ${theme.screenXS}px)`),
    isTablet: useMediaQuery(
      `(min-width: ${theme.screenSM}px) and (max-width: ${theme.screenMD - 1}px)`,
    ),
    isDesktop: useMediaQuery(`(min-width: ${theme.screenMD}px)`),
    isLarge: useMediaQuery(`(min-width: ${theme.screenLG}px)`),
    isExtraLarge: useMediaQuery(`(min-width: ${theme.screenXL}px)`),
    isExtraExtraLarge: useMediaQuery(`(min-width: ${theme.screenXXL}px)`),
  };
};
